webpackJsonp([0],{

/***/ 276:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlertState = undefined;
	exports.alertReducer = alertReducer;
	
	var _immutable = __webpack_require__(239);
	
	var _auth = __webpack_require__(236);
	
	var _actionTypes = __webpack_require__(275);
	
	var AlertState = exports.AlertState = new _immutable.Record({
	  actionLabel: '',
	  display: false,
	  message: ''
	});
	
	function alertReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AlertState();
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _auth.SIGN_IN_ERROR:
	      return state.merge({
	        actionLabel: 'Undo',
	        display: true,
	        message: action.payload.message
	      });
	    case _auth.SIGN_UP_ERROR:
	      return state.merge({
	        actionLabel: 'Undo',
	        display: true,
	        message: action.payload.message
	      });
	
	    case _actionTypes.DISMISS_ALERT:
	      return new AlertState();
	
	    default:
	      return new AlertState();
	  }
	}

/***/ },

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },

/***/ 236:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isAuthenticated = exports.getAuth = exports.authReducer = exports.authActions = undefined;
	
	var _actionTypes = __webpack_require__(237);
	
	Object.keys(_actionTypes).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actionTypes[key];
	    }
	  });
	});
	
	var _reducer = __webpack_require__(238);
	
	Object.defineProperty(exports, 'authReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.authReducer;
	  }
	});
	
	var _selectors = __webpack_require__(240);
	
	Object.defineProperty(exports, 'getAuth', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.getAuth;
	  }
	});
	Object.defineProperty(exports, 'isAuthenticated', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.isAuthenticated;
	  }
	});
	exports.initAuth = initAuth;
	
	var _firebase = __webpack_require__(241);
	
	var _actions = __webpack_require__(249);
	
	var authActions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.authActions = authActions;
	function initAuth(dispatch) {
	  return new Promise(function (resolve, reject) {
	    var unsub = _firebase.firebaseAuth.onAuthStateChanged(function (user) {
	      dispatch(authActions.initAuth(user));
	      unsub();
	      resolve();
	    }, function (error) {
	      return reject(error);
	    });
	  });
	}

/***/ },

/***/ 237:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INIT_AUTH = exports.INIT_AUTH = 'INIT_AUTH';
	var START_LOGIN = exports.START_LOGIN = 'START_LOGIN';
	var SIGN_IN_ERROR = exports.SIGN_IN_ERROR = 'SIGN_IN_ERROR';
	
	var SIGN_IN_SUCCESS = exports.SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
	var SIGN_IN_EMAIL_PASSWORD_SUCCESS = exports.SIGN_IN_EMAIL_PASSWORD_SUCCESS = 'SIGN_IN_EMAIL_PASSWORD_SUCCESS';
	
	var START_SIGN_UP = exports.START_SIGN_UP = 'START_SIGN_UP';
	var SIGN_UP_SUCCESS = exports.SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
	var SIGN_UP_ERROR = exports.SIGN_UP_ERROR = 'SIGN_UP_ERROR';
	
	var SIGN_OUT_SUCCESS = exports.SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';

/***/ },

/***/ 238:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthState = undefined;
	exports.authReducer = authReducer;
	
	var _immutable = __webpack_require__(239);
	
	var _actionTypes = __webpack_require__(237);
	
	var AuthState = exports.AuthState = new _immutable.Record({
	  loading: false,
	  authenticated: false,
	  id: null
	});
	
	function authReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AuthState();
	  var _ref = arguments[1];
	  var payload = _ref.payload,
	      type = _ref.type;
	
	  switch (type) {
	    case _actionTypes.START_LOGIN:
	      return state.merge({
	        loading: true
	      });
	    case _actionTypes.SIGN_IN_ERROR:
	      return state.merge({
	        loading: false
	      });
	    case _actionTypes.START_SIGN_UP:
	      return state.merge({
	        loading: true
	      });
	    case _actionTypes.SIGN_UP_ERROR:
	      return state.merge({
	        loading: false
	      });
	    case _actionTypes.INIT_AUTH:
	    case _actionTypes.SIGN_IN_SUCCESS:
	      return state.merge({
	        loading: false,
	        authenticated: !!payload,
	        id: payload ? payload.uid : null
	      });
	    case _actionTypes.SIGN_OUT_SUCCESS:
	      return new AuthState();
	
	    default:
	      return state;
	  }
	}

/***/ },

/***/ 240:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuth = getAuth;
	exports.isAuthenticated = isAuthenticated;
	function getAuth(state) {
	  return state.auth;
	}
	
	function isAuthenticated(state) {
	  return getAuth(state).authenticated;
	}

/***/ },

/***/ 241:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(242);
	
	Object.defineProperty(exports, 'firebaseApp', {
	  enumerable: true,
	  get: function get() {
	    return _firebase.firebaseApp;
	  }
	});
	Object.defineProperty(exports, 'firebaseAuth', {
	  enumerable: true,
	  get: function get() {
	    return _firebase.firebaseAuth;
	  }
	});
	Object.defineProperty(exports, 'firebaseDb', {
	  enumerable: true,
	  get: function get() {
	    return _firebase.firebaseDb;
	  }
	});

/***/ },

/***/ 242:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.firebaseDb = exports.firebaseAuth = exports.firebaseApp = undefined;
	
	var _firebase = __webpack_require__(243);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _config = __webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var firebaseApp = exports.firebaseApp = _firebase2.default.initializeApp(_config.firebaseConfig);
	var firebaseAuth = exports.firebaseAuth = firebaseApp.auth();
	var firebaseDb = exports.firebaseDb = firebaseApp.database();

/***/ },

/***/ 248:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var firebaseConfig = exports.firebaseConfig = {
	  apiKey: 'AIzaSyDJJEBJzkpgjNeFQGGmUkzsNA2vOhnUlwI',
	  authDomain: 'login-react-redux.firebaseapp.com',
	  databaseURL: 'https://login-react-redux.firebaseio.com/',
	  storageBucket: 'login-react-redux.appspot.com'
	};

/***/ },

/***/ 249:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initAuth = initAuth;
	exports.signInError = signInError;
	exports.signInSuccess = signInSuccess;
	exports.signInEmailPasswordSuccess = signInEmailPasswordSuccess;
	exports.signUpError = signUpError;
	exports.signUpSuccess = signUpSuccess;
	exports.signUp = signUp;
	exports.signInWithLoginAndPassword = signInWithLoginAndPassword;
	exports.signInWithGithub = signInWithGithub;
	exports.signInWithGoogle = signInWithGoogle;
	exports.signInWithTwitter = signInWithTwitter;
	exports.signInWithFacebook = signInWithFacebook;
	exports.signOut = signOut;
	exports.signOutSuccess = signOutSuccess;
	
	var _firebase = __webpack_require__(243);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _firebase3 = __webpack_require__(241);
	
	var _actionTypes = __webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function authenticateWithProvider(provider) {
	  return function (dispatch) {
	    _firebase3.firebaseAuth.signInWithPopup(provider).then(function (result) {
	      return dispatch(signInSuccess(result));
	    }).catch(function (error) {
	      return dispatch(signInError(error));
	    });
	  };
	}
	
	function authenticateWithEmailAndPassword(email, password) {
	  return function (dispatch) {
	
	    dispatch({ type: _actionTypes.START_LOGIN });
	
	    _firebase3.firebaseAuth.signInWithEmailAndPassword(email, password).then(function (result) {
	      return dispatch(signInEmailPasswordSuccess(result));
	    }).catch(function (error) {
	      return dispatch(signInError(error));
	    });
	  };
	}
	
	function createUserWithEmailAndPassword(email, password) {
	  return function (dispatch) {
	
	    dispatch({ type: _actionTypes.START_SIGN_UP });
	
	    _firebase3.firebaseAuth.createUserWithEmailAndPassword(email, password).then(function (result) {
	      return dispatch(signUpSuccess(result));
	    }).catch(function (error) {
	      return dispatch(signUpError(error));
	    });
	  };
	}
	
	function initAuth(user) {
	  return {
	    type: _actionTypes.INIT_AUTH,
	    payload: user
	  };
	}
	
	function signInError(error) {
	  return {
	    type: _actionTypes.SIGN_IN_ERROR,
	    payload: error
	  };
	}
	
	function signInSuccess(result) {
	  return {
	    type: _actionTypes.SIGN_IN_SUCCESS,
	    payload: result.user
	  };
	}
	
	function signInEmailPasswordSuccess(result) {
	  return {
	    type: _actionTypes.SIGN_IN_SUCCESS,
	    payload: result
	  };
	}
	
	function signUpError(error) {
	  return {
	    type: _actionTypes.SIGN_UP_ERROR,
	    payload: error
	  };
	}
	
	function signUpSuccess(result) {
	  return {
	    type: _actionTypes.SIGN_IN_SUCCESS,
	    payload: result
	  };
	}
	
	function signUp(email, password) {
	  return createUserWithEmailAndPassword(email, password);
	}
	
	function signInWithLoginAndPassword(email, password) {
	  return authenticateWithEmailAndPassword(email, password);
	}
	
	function signInWithGithub() {
	  return authenticateWithProvider(new _firebase2.default.auth.GithubAuthProvider());
	}
	
	function signInWithGoogle() {
	  return authenticateWithProvider(new _firebase2.default.auth.GoogleAuthProvider());
	}
	
	function signInWithTwitter() {
	  return authenticateWithProvider(new _firebase2.default.auth.TwitterAuthProvider());
	}
	
	function signInWithFacebook() {
	  return authenticateWithProvider(new _firebase2.default.auth.FacebookAuthProvider());
	}
	
	function signOut() {
	  return function (dispatch) {
	    _firebase3.firebaseAuth.signOut().then(function () {
	      return dispatch(signOutSuccess());
	    });
	  };
	}
	
	function signOutSuccess() {
	  return {
	    type: _actionTypes.SIGN_OUT_SUCCESS
	  };
	}

/***/ },

/***/ 250:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(251);
	
	var _reduxThunk = __webpack_require__(272);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(273);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var middleware = (0, _redux.applyMiddleware)(_reduxThunk2.default);
	
	  // if (process.env.NODE_ENV !== 'production') {
	  //   const devToolsExtension = window.devToolsExtension;
	  //   if (typeof devToolsExtension === 'function') {
	  //     middleware = compose(middleware, devToolsExtension());
	  //   }
	  // }
	
	  var store = (0, _redux.createStore)(_reducers2.default, initialState, middleware);
	
	  // if (module.hot) {
	  //   module.hot.accept('./reducers', () => {
	  //     store.replaceReducer(require('./reducers').default);
	  //   });
	  // }
	
	  return store;
	};

/***/ },

/***/ 273:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRouterRedux = __webpack_require__(231);
	
	var _redux = __webpack_require__(251);
	
	var _auth = __webpack_require__(236);
	
	var _alerts = __webpack_require__(274);
	
	exports.default = (0, _redux.combineReducers)({
	  auth: _auth.authReducer,
	  alert: _alerts.alertReducer,
	  routing: _reactRouterRedux.routerReducer
	});

/***/ },

/***/ 274:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAlert = exports.alertReducer = exports.alertActions = undefined;
	
	var _actionTypes = __webpack_require__(275);
	
	Object.keys(_actionTypes).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actionTypes[key];
	    }
	  });
	});
	
	var _reducer = __webpack_require__(276);
	
	Object.defineProperty(exports, 'alertReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.alertReducer;
	  }
	});
	
	var _selectors = __webpack_require__(277);
	
	Object.defineProperty(exports, 'getAlert', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.getAlert;
	  }
	});
	
	var _actions = __webpack_require__(278);
	
	var alertActions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.alertActions = alertActions;

/***/ },

/***/ 275:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DISMISS_ALERT = exports.DISMISS_ALERT = 'DISMISS_ALERT';

/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactHotLoader = __webpack_require__(164);
	
	var _reactRouter = __webpack_require__(168);
	
	var _reactRouterRedux = __webpack_require__(231);
	
	var _auth = __webpack_require__(236);
	
	var _store = __webpack_require__(250);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _root = __webpack_require__(279);
	
	var _root2 = _interopRequireDefault(_root);
	
	__webpack_require__(298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _store2.default)();
	var syncedHistory = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	var rootElement = document.getElementById('root');
	
	// ========================================================
	// Render Setup
	// ========================================================
	
	var _ref = _jsx(_reactHotLoader.AppContainer, {}, void 0, _jsx(_root2.default, {
	  history: syncedHistory,
	  store: store
	}));
	
	function render() {
	  _reactDom2.default.render(_ref, rootElement);
	}
	
	// ========================================================
	// Render
	// ========================================================
	
	(0, _auth.initAuth)(store.dispatch).then(function () {
	  return render(_root2.default);
	}).catch(function (error) {
	  return console.error(error);
	}); // eslint-disable-line no-console

/***/ },

/***/ 277:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAlert = getAlert;
	function getAlert(state) {
	  return state.alert;
	}

/***/ },

/***/ 278:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dismissAlert = dismissAlert;
	
	var _actionTypes = __webpack_require__(275);
	
	function dismissAlert() {
	  return {
	    type: _actionTypes.DISMISS_ALERT
	  };
	}

/***/ },

/***/ 279:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = Root;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(280);
	
	var _reactRouter = __webpack_require__(168);
	
	var _routes = __webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Root(_ref) {
	  var history = _ref.history,
	      store = _ref.store;
	
	  return _jsx(_reactRedux.Provider, {
	    store: store
	  }, void 0, _jsx(_reactRouter.Router, {
	    history: history,
	    routes: (0, _routes.getRoutes)(store.getState)
	  }));
	}

/***/ },

/***/ 287:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRoutes = exports.paths = undefined;
	
	var _auth = __webpack_require__(236);
	
	var _app = __webpack_require__(288);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _signIn = __webpack_require__(292);
	
	var _signIn2 = _interopRequireDefault(_signIn);
	
	var _signUp = __webpack_require__(295);
	
	var _signUp2 = _interopRequireDefault(_signUp);
	
	var _home = __webpack_require__(297);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paths = exports.paths = {
	  ROOT: '/',
	  SIGN_IN: '/sign-in',
	  SIGN_UP: '/sign-up',
	  HOME: '/'
	};
	
	var requireAuth = function requireAuth(getState) {
	  return function (nextState, replace) {
	    if (!(0, _auth.isAuthenticated)(getState())) {
	      replace(paths.SIGN_IN);
	    }
	  };
	};
	
	var requireUnauth = function requireUnauth(getState) {
	  return function (nextState, replace) {
	    if ((0, _auth.isAuthenticated)(getState())) {
	      replace(paths.HOME);
	    }
	  };
	};
	
	var getRoutes = exports.getRoutes = function getRoutes(getState) {
	  return {
	    path: paths.ROOT,
	    component: _app2.default,
	    childRoutes: [{
	      indexRoute: {
	        component: _home2.default,
	        onEnter: requireAuth(getState)
	      }
	    }, {
	      path: paths.SIGN_IN,
	      component: _signIn2.default,
	      onEnter: requireUnauth(getState)
	    }, {
	      path: paths.SIGN_UP,
	      component: _signUp2.default,
	      onEnter: requireUnauth(getState)
	    }]
	  };
	};

/***/ },

/***/ 288:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.App = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(280);
	
	var _reselect = __webpack_require__(289);
	
	var _auth = __webpack_require__(236);
	
	var _routes = __webpack_require__(287);
	
	var _header = __webpack_require__(290);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _classnames = __webpack_require__(291);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = exports.App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var router = this.context.router;
	      var auth = this.props.auth;
	
	
	      if (auth.authenticated && !nextProps.auth.authenticated) {
	        router.replace(_routes.paths.SIGN_IN);
	      } else if (!auth.authenticated && nextProps.auth.authenticated) {
	        router.replace(_routes.paths.HOME);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _jsx('div', {}, void 0, _jsx('div', {
	        className: (0, _classnames2.default)({ 'loading-app': this.props.auth.loading })
	      }), _jsx(_header2.default, {
	        authenticated: this.props.auth.authenticated,
	        signOut: this.props.signOut
	      }), _jsx('main', {
	        className: 'main'
	      }, void 0, this.props.children));
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	//=====================================
	//  CONNECT
	//-------------------------------------
	
	App.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	var mapStateToProps = (0, _reselect.createSelector)(_auth.getAuth, function (auth) {
	  return { auth: auth };
	});
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, _auth.authActions)(App);

/***/ },

/***/ 290:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx("h1", {
	  className: "header__title"
	}, void 0, "Login with React + Redux + Firebase");
	
	var _ref3 = _jsx("li", {}, void 0, _jsx("a", {
	  target: "_blank",
	  className: "link link--github",
	  href: "https://github.com/jvcjunior/login-react-redux"
	}));
	
	var Header = function Header(_ref) {
	  var authenticated = _ref.authenticated,
	      signOut = _ref.signOut;
	
	  return _jsx("header", {
	    className: "header"
	  }, void 0, _jsx("div", {
	    className: "g-row"
	  }, void 0, _jsx("div", {
	    className: "g-col"
	  }, void 0, _ref2, _jsx("ul", {
	    className: "header__actions"
	  }, void 0, authenticated ? _jsx("li", {}, void 0, _jsx("button", {
	    className: "btn",
	    onClick: signOut
	  }, void 0, "Sign out")) : null, _ref3))));
	};
	
	exports.default = Header;

/***/ },

/***/ 291:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },

/***/ 292:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SignIn = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(280);
	
	var _auth = __webpack_require__(236);
	
	var _reselect = __webpack_require__(289);
	
	var _alerts = __webpack_require__(274);
	
	var _alert = __webpack_require__(293);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _loginForm = __webpack_require__(294);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('div', {
	  className: 'sign-up__actions clearfix'
	}, void 0, _jsx('p', {}, void 0, 'Not a member? ', _jsx('a', {
	  href: '/sign-up'
	}, void 0, 'Sign up now'), _jsx('span', {
	  className: 'fa fa-arrow-right'
	})));
	
	var SignIn = exports.SignIn = function (_Component) {
	  _inherits(SignIn, _Component);
	
	  function SignIn(props) {
	    _classCallCheck(this, SignIn);
	
	    return _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this, props));
	  }
	
	  _createClass(SignIn, [{
	    key: 'renderAlert',
	    value: function renderAlert() {
	      var alert = this.props.alert;
	
	      return _jsx(_alert2.default, {
	        dismiss: this.props.dismissAlert,
	        display: alert.display,
	        message: alert.message
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _jsx('div', {
	        className: 'container'
	      }, void 0, _jsx(_loginForm2.default, {
	        signInWithLoginAndPassword: this.props.signInWithLoginAndPassword.bind(this)
	      }), _ref, _jsx('div', {
	        className: 'sign-in__actions clearfix'
	      }, void 0, _jsx('ul', {}, void 0, _jsx('li', {}, void 0, _jsx('a', {
	        onClick: this.props.signInWithGithub.bind(this),
	        className: 'link link-github'
	      })), _jsx('li', {}, void 0, _jsx('a', {
	        onClick: this.props.signInWithGoogle.bind(this),
	        className: 'link link-google'
	      })), _jsx('li', {}, void 0, _jsx('a', {
	        onClick: this.props.signInWithTwitter.bind(this),
	        className: 'link link-twitter'
	      })), _jsx('li', {}, void 0, _jsx('a', {
	        onClick: this.props.signInWithFacebook.bind(this),
	        className: 'link link-facebook'
	      })))), this.props.alert.display ? this.renderAlert() : null);
	    }
	  }]);
	
	  return SignIn;
	}(_react.Component);
	
	//=====================================
	//  CONNECT
	//-------------------------------------
	
	var mapStateToProps = (0, _reselect.createSelector)(_alerts.getAlert, function (alert) {
	  return { alert: alert };
	});
	
	var mapDispatchToProps = Object.assign({}, _auth.authActions, _alerts.alertActions);
	
	//export default connect(null, authActions)(SignIn);
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SignIn);

/***/ },

/***/ 293:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alert = function (_Component) {
	  _inherits(Alert, _Component);
	
	  function Alert() {
	    _classCallCheck(this, Alert);
	
	    return _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).apply(this, arguments));
	  }
	
	  _createClass(Alert, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startTimer();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.display) {
	        this.startTimer();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearTimer();
	    }
	  }, {
	    key: "clearTimer",
	    value: function clearTimer() {
	      if (this.timerId) {
	        clearTimeout(this.timerId);
	      }
	    }
	  }, {
	    key: "startTimer",
	    value: function startTimer() {
	      var _this2 = this;
	
	      this.clearTimer();
	      this.timerId = setTimeout(function () {
	        _this2.props.dismiss();
	      }, this.props.duration || 5000);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _jsx("div", {
	        className: "alert"
	      }, void 0, _react2.default.createElement(
	        "p",
	        { className: "alert__message", ref: function ref(c) {
	            return _this3.message = c;
	          } },
	        this.props.message
	      ));
	    }
	  }]);
	
	  return Alert;
	}(_react.Component);
	
	exports.default = Alert;

/***/ },

/***/ 294:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx("span", {
	  className: "fa fa-user"
	});
	
	var _ref2 = _jsx("span", {
	  className: "fa fa-lock"
	});
	
	var _ref3 = _jsx("input", {
	  type: "submit",
	  value: "Log in"
	});
	
	var LoginForm = function (_Component) {
	  _inherits(LoginForm, _Component);
	
	  function LoginForm(props, context) {
	    _classCallCheck(this, LoginForm);
	
	    var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props, context));
	
	    _this.state = { user: {} };
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(LoginForm, [{
	    key: "clearInput",
	    value: function clearInput() {
	      this.setState({ user: {} });
	    }
	  }, {
	    key: "handleChange",
	    value: function handleChange(propertyName, event) {
	      var user = this.state.user;
	      user[propertyName] = event.target.value;
	      this.setState({ user: user });
	    }
	  }, {
	    key: "onSubmit",
	    value: function onSubmit(event) {
	      event.preventDefault();
	      var login = this.state.user.email.trim();
	      var password = this.state.user.password.trim();
	      if (login.length && password.length) this.props.signInWithLoginAndPassword(login, password);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _jsx("div", {
	        id: "login"
	      }, void 0, _jsx("form", {
	        className: "login-form",
	        onSubmit: this.onSubmit
	      }, void 0, _ref, _jsx("input", {
	        autoFocus: true,
	        maxLength: "25",
	        onChange: this.handleChange.bind(this, 'email'),
	        placeholder: "Email",
	        type: "email",
	        value: this.state.user.email,
	        required: true
	      }), _ref2, _jsx("input", {
	        autoComplete: "off",
	        maxLength: "8",
	        onChange: this.handleChange.bind(this, 'password'),
	        placeholder: "Password",
	        type: "password",
	        value: this.state.user.password,
	        required: true
	      }), _ref3));
	    }
	  }]);
	
	  return LoginForm;
	}(_react.Component);
	
	exports.default = LoginForm;

/***/ },

/***/ 295:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.SignUp = SignUp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(280);
	
	var _signUp = __webpack_require__(296);
	
	var _signUp2 = _interopRequireDefault(_signUp);
	
	var _auth = __webpack_require__(236);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SignUp(_ref) {
	  var signUp = _ref.signUp;
	
	  return _jsx('div', {
	    className: 'container'
	  }, void 0, _jsx(_signUp2.default, {
	    signUp: signUp
	  }));
	}
	
	//=====================================
	//  CONNECT
	//-------------------------------------
	
	exports.default = (0, _reactRedux.connect)(null, _auth.authActions)(SignUp);

/***/ },

/***/ 296:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx("span", {
	  className: "fa fa-user"
	});
	
	var _ref2 = _jsx("span", {
	  className: "fa fa-lock"
	});
	
	var _ref3 = _jsx("span", {
	  className: "fa fa-lock"
	});
	
	var _ref4 = _jsx("input", {
	  type: "submit",
	  value: "Sign Up"
	});
	
	var SignUpForm = function (_Component) {
	  _inherits(SignUpForm, _Component);
	
	  function SignUpForm(props, context) {
	    _classCallCheck(this, SignUpForm);
	
	    var _this = _possibleConstructorReturn(this, (SignUpForm.__proto__ || Object.getPrototypeOf(SignUpForm)).call(this, props, context));
	
	    _this.state = { newUser: {} };
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(SignUpForm, [{
	    key: "clearInput",
	    value: function clearInput() {
	      this.setState({ user: {} });
	    }
	  }, {
	    key: "handleChange",
	    value: function handleChange(propertyName, event) {
	      var newUser = this.state.newUser;
	      newUser[propertyName] = event.target.value;
	      this.setState({ newUser: newUser });
	    }
	  }, {
	    key: "onSubmit",
	    value: function onSubmit(event) {
	      event.preventDefault();
	      var login = this.state.newUser.email.trim();
	      var password = this.state.newUser.password.trim();
	      var passwordConfirmation = this.state.newUser.passwordConfirmation.trim();
	      if (password.length && password === passwordConfirmation) this.props.signUp(login, password);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _jsx("div", {
	        id: "login"
	      }, void 0, _jsx("form", {
	        className: "login-form",
	        onSubmit: this.onSubmit
	      }, void 0, _ref, _jsx("input", {
	        autoFocus: true,
	        maxLength: "25",
	        onChange: this.handleChange.bind(this, 'email'),
	        placeholder: "Email",
	        type: "email",
	        value: this.state.newUser.email,
	        required: true
	      }), _ref2, _jsx("input", {
	        autoComplete: "off",
	        maxLength: "8",
	        onChange: this.handleChange.bind(this, 'password'),
	        placeholder: "Password",
	        type: "password",
	        value: this.state.newUser.password,
	        required: true
	      }), _ref3, _jsx("input", {
	        autoComplete: "off",
	        maxLength: "8",
	        onChange: this.handleChange.bind(this, 'passwordConfirmation'),
	        placeholder: "Confirm your Password",
	        type: "password",
	        value: this.state.newUser.passwordConfirmation,
	        required: true
	      }), _ref4));
	    }
	  }]);
	
	  return SignUpForm;
	}(_react.Component);
	
	exports.default = SignUpForm;

/***/ },

/***/ 297:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Home = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(239);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(280);
	
	var _reselect = __webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('div', {
	  className: 'g-row'
	}, void 0, _jsx('div', {
	  className: 'g-col'
	}, void 0, _jsx('h1', {}, void 0, 'HOME')));
	
	var Home = exports.Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
	  }
	
	  _createClass(Home, [{
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	
	  return Home;
	}(_react.Component);
	
	exports.default = Home;

/***/ },

/***/ 298:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }

});


// WEBPACK FOOTER //
// main.4a70c53ea51c9292ca60.js